import React from 'react';
import { useTranslation } from 'react-i18next';

const summaryValues = ['€9.200', '€2.800', '€450'];
const summaryColors = ['#22c55e', '#f59e0b', '#ef4444'];

const InvoiceSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.invoice', { returnObjects: true }) as any;
  const labels = m.summaryLabels as string[];
  const th = m.th as string[];
  const rows = m.rows as any[];

  return (
    <div className="dt-mockup-invoice">
      <div className="dt-invoice-toolbar">
        <span className="dt-invoice-toolbar-title">{m.toolbarTitle}</span>
        <span className="dt-invoice-toolbar-badge">{m.toolbarBadge}</span>
      </div>
      <div className="dt-invoice-summary">
        {labels.map((label: string, i: number) => (
          <div key={label} className="dt-invoice-summary-card">
            <div className="dt-invoice-summary-value" style={{ color: summaryColors[i] }}>{summaryValues[i]}</div>
            <div className="dt-invoice-summary-label">{label}</div>
          </div>
        ))}
      </div>
      <div className="dt-invoice-table">
        <div className="dt-invoice-table-head">
          {th.map((h: string) => <span key={h}>{h}</span>)}
        </div>
        {rows.map((r: any) => (
          <div key={r.nr} className="dt-invoice-table-row">
            <span className="dt-invoice-nr">{r.nr}</span>
            <span>{r.client}</span>
            <span>{r.amount}</span>
            <span className={`dt-invoice-status dt-invoice-status--${r.statusClass}`}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceSlide;
